/** The approved PhaseDrift mark, shared unchanged with the public website. */
export function BrandMark({ darkUrl = '/brand/phasedrift-mark-dark.svg', lightUrl = '/brand/phasedrift-mark-light.svg' }: { darkUrl?: string; lightUrl?: string } = {}) {
  return <span className="phasedrift-brand-mark" aria-hidden="true">
    <img className="brand-on-dark" src={darkUrl} width="40" height="32" alt="" />
    <img className="brand-on-light" src={lightUrl} width="40" height="32" alt="" />
  </span>;
}
